var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "contact-list-index-page pt-3", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c(
              "div",
              { staticClass: "border border-gray-500 contact-list-container" },
              [
                _c(
                  "div",
                  { staticClass: "py-2 bg-gray-500 text-center header" },
                  [_c("h5", { staticClass: "mb-0" }, [_vm._v("CONTACT LISTS")])]
                ),
                _vm._v(" "),
                _c(
                  "contact-list-list",
                  _vm._b(
                    { ref: "contactListList" },
                    "contact-list-list",
                    _vm.contactListList,
                    false
                  )
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 12 } }, [
            _c(
              "div",
              { staticClass: "border border-gray-500 contact-list-container" },
              [
                _c(
                  "div",
                  { staticClass: "py-2 bg-gray-500 text-center header" },
                  [_c("h5", { staticClass: "mb-0" }, [_vm._v("CONTACTS")])]
                ),
                _vm._v(" "),
                _vm.isContactListSelected
                  ? _c(
                      "contact-list",
                      _vm._b(
                        {
                          key: _vm.contactListKey,
                          attrs: { "contact-list": _vm.currentContactList },
                        },
                        "contact-list",
                        _vm.contactList,
                        false
                      )
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("contact-list-form-wrapper"),
      _vm._v(" "),
      _c("contact-form-wrapper"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }